export default __webpack_public_path__ + "368a159dbdc5f5f3731d67c340e185a4.png";